// pontuar-abastecimento-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Preço unitário:": "Precio unitario:",
};

export default catalogo;
